import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/dropDownElements')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/dropDownElement' })
  },
})
